// extracted by mini-css-extract-plugin
export default {"wrapper":"table-actions_wrapper__xd6lD"};